import { render, staticRenderFns } from "./product_inventory.vue?vue&type=template&id=652b2460&"
import script from "./product_inventory.vue?vue&type=script&lang=js&"
export * from "./product_inventory.vue?vue&type=script&lang=js&"
import style0 from "./product_inventory.vue?vue&type=style&index=0&id=652b2460&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports